import React, { useState, useEffect } from "react";
import { ethers } from "ethers";

const FetchPaymasterBalance = ({ fastestWebSocket, paymasterAddress, onBalanceFetched }) => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPaymasterBalance = async () => {
    setLoading(true);
    setError(null);
    try {
      // Connect to the AVAX provider
      const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);

      // Fetch the balance of the paymaster address
      const balanceInWei = await provider.getBalance(paymasterAddress);

      // Convert balance from wei to AVAX
      const balanceInEth = parseFloat(ethers.utils.formatEther(balanceInWei)).toFixed(3);

      // Update state with the fetched balance
      setBalance(balanceInEth);

      // Pass the balance to the parent component
      if (onBalanceFetched) {
        onBalanceFetched(balanceInEth);
      }
    } catch (err) {
      setError(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (paymasterAddress) {
      fetchPaymasterBalance();
    }
  }, [paymasterAddress]);

  if (loading) return <p>Loading balance...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return <p><strong>Paymaster Balance:</strong> {balance} ETH</p>;
};

export default FetchPaymasterBalance;
